import { exchangeApi, certificationApi } from '@/api';
import { addClass, removeClass } from '@/utils';
import { API_RETURN_CODE } from '@/utils/variables';

const actions = {};

/**
 * 포인트 전환 단계 저장
 *  @param {*} param0
 *  @param {String} val
 */
actions.setExchangeStep = ({ commit }, val) => {
  commit('SET_EXCHANGESTEP', val);
};

/**
 * 포인트 전환 가능 여부 체크
 *  @param {*} param0
 */
actions.checkExchange = ({ commit }) => {
  return exchangeApi.checkExchange().then((res) => {
    if (res.data.code === API_RETURN_CODE.NO_ERROR) {
      // commit('SET_EXCHANGECURRENCY', res.data.data);
    }

    return res.data;
  });
};

actions.checkGlobalExchange = ({ commit }, njPointWithdraw = false) => {
  if (njPointWithdraw) {
    return exchangeApi.checkGlobalExchangeNexonPoint().then((res) => {
      return res.data;
    });
  }

  return exchangeApi.checkGlobalExchange().then((res) => {
    return res.data;
  });
};

actions.getExchangeInfo = ({ commit }, isNjPointEnable = false) => {
  if (isNjPointEnable) {
    return exchangeApi.getExchangeNexonPointInfo().then((res) => {
      if (res.data.code === API_RETURN_CODE.NO_ERROR) {
        commit('SET_EXCHANGECURRENCY', res.data.data);
      }

      return res.data;
    });
  }

  return exchangeApi.getExchangeInfo().then((res) => {
    if (res.data.code === API_RETURN_CODE.NO_ERROR) {
      commit('SET_EXCHANGECURRENCY', res.data.data);
    }

    return res.data;
  });
};

/**
 * 전환 포인트 저장
 *  @param {*} param0
 *  @param {Number} val
 */
actions.setExchangePoint = ({ commit }, val) => {
  commit('SET_EXCHANGEPOINT', val);
};

/**
 * 포인트 전환 정보
 *  @param {*} param0
 *  @param {Array} value
 */
actions.getExchangeInit = ({ commit }, val) => {
  return exchangeApi.getExchangeInit(val).then((res) => {
    if (res.data.code === API_RETURN_CODE.NO_ERROR) {
      commit('GET_EXCHANGEINIT', res.data.data);
    }

    return res.data.code;
  });
};

/**
 * 우편번호 변경
 *  @param {*} param0
 *  @param {String} val
 */
actions.setZipCode = ({ commit }, val) => {
  commit('SET_ZIPCODE', val);
  commit('SET_EXCHANGECONTACTSTATE');
};

/**
 * 기본 주소 변경
 *  @param {*} param0
 *  @param {String} val
 */
actions.setAddress1 = ({ commit }, val) => {
  commit('SET_ADDRESS1', val);
  commit('SET_EXCHANGECONTACTSTATE');
};

/**
 * 상세 주소 변경
 *  @param {*} param0
 *  @param {String} val
 */
actions.setAddress2 = ({ commit }, val) => {
  commit('SET_ADDRESS2', val);
  commit('SET_EXCHANGECONTACTSTATE');
};
/**
 * 연락처 앞자리 변경
 *  @param {*} param0
 *  @param {Number} val
 */
actions.setTelNoFront = ({ commit }, val) => {
  commit('SET_TELNOFRONT', val);
};
/**
 * 연락처 중간자리 변경
 *  @param {*} param0
 *  @param {Number} val
 */
actions.setTelNoMiddle = ({ commit }, val) => {
  commit('SET_TELNOMIDDLE', val);
};
/**
 * 연락처 끝자리 변경
 *  @param {*} param0
 *  @param {Number} val
 */
actions.setTelNoBack = ({ commit }, val) => {
  commit('SET_TELNOBACK', val);
};
/**
 * 연락처 변경
 *  @param {*} param0
 *  @param {String} val
 */
actions.setTelNo = ({ commit }, val) => {
  commit('SET_TELNO', val);
  commit('SET_EXCHANGECONTACTSTATE');
};

/**
 * 연락처 입력 상태 정보
 *  @param {*} param0
 */
actions.setExchangeContactState = ({ commit }) => {
  commit('SET_EXCHANGECONTACTSTATE');
};

/**
 * 포인트 전환 신청 가능 은행 목록
 *  @param {*} param0
 */
actions.getBankList = ({ commit }) => {
  return exchangeApi.getBankList().then((res) => {
    if (res.data.code === API_RETURN_CODE.NO_ERROR) {
      commit('GET_BANKLIST', res.data.data.bankList);
    }
    return res.data;
  });
};

/**
 * 은행명 변경
 *  @param {*} param0
 *  @param {Number} val
 */
actions.setBankName = ({ commit }, val) => {
  commit('SET_BANKNAME', val);
  commit('SET_EXCHANGEACCOUNTSTATE', false);
};

/**
 * 계좌번호 변경
 *  @param {*} param0
 *  @param {String} val
 */
actions.setAccountNo = ({ commit }, val) => {
  commit('SET_ACCOUNTNO', val);
  commit('SET_EXCHANGEACCOUNTSTATE', false);
};

/**
 * 계좌 실명 인증
 *  @param {*} param0
 *  @param {Object} val
 */
actions.checkBankAccount = ({ commit }, val) => {
  return certificationApi.checkBankAccount(val).then((res) => {
    if (res.data.code === API_RETURN_CODE.NO_ERROR) {
      commit('SET_EXCHANGEACCOUNT', val);
      commit('SET_EXCHANGEACCOUNTSTATE', true);
    }

    return res.data;
  });
};

/**
 * 계좌정보 수정
 *  @param {*} param0
 *  @param {Array} val
 */
actions.setExchangeAccountModify = ({ commit }, val) => {
  commit('SET_EXCHANGEACCOUNTDISPLAY', false);
  commit('SET_EXCHANGEACCOUNTSTATE', false);
  commit('SET_BANKSELECT', val[0]);
  commit('SET_ACCOUNTNO', val[1]);
};

/**
 * 계좌정보 인증 상태
 *  @param {*} param0
 *  @param {Boolean} val
 */
actions.setExchangeAccountState = ({ commit }, val) => {
  commit('SET_EXCHANGEACCOUNTSTATE', val);
};

/**
 * 계좌레이어 인증 상태
 *  @param {*} param0
 *  @param {Boolean} val
 */
actions.setExchangeAccountLayerState = ({ commit }, val) => {
  commit('SET_EXCHANGEACCOUNTLAYERSTATE', val);
};

/**
 * 계좌정보 저장
 *  @param {*} param0
 *  @param {Object} val
 */
actions.setExchangeAccountRegist = ({ commit }, val) => {
  return exchangeApi.setExchangeAccountRegist(val).then((res) => {
    if (res.data.code === API_RETURN_CODE.NO_ERROR) {
      commit('SET_EXCHANGEACCOUNTREGIST', res.data.data);
    }

    return res.data;
  });
};

/**
 * 개인정보 수집 동의
 *  @param {*} param0
 *  @param {Boolean} val
 */
actions.setExchangeAgree = ({ commit }, val) => {
  commit('SET_EXCHANGEAGREE', val);
};

/**
 * 전환신청
 *  @param {*} param0
 *  @param {Object} val
 */
actions.setExchangeRequest = ({ commit }, val) => {
  return exchangeApi.setExchangeRequest(val).then((res) => {
    return res.data;
  });
};

/**
 * Exchange 내역
 *  @param {*} param0
 *  @param {Object} val
 */
actions.getExchangeHistory = ({ commit }, val) => {
  return exchangeApi.getExchangeHistory(val).then((res) => {
    if (res.data.code === API_RETURN_CODE.NO_ERROR) {
      commit('SET_EXCHANGEHISTORY', res.data.data);
    }

    return res.data.code;
  });
};

/**
 * Exchange global 내역
 *  @param {*} param0
 *  @param {Object} val
 */
actions.getGlobalExchangeHistory = ({ commit }, val) => {
  return exchangeApi.getGlobalExchangeHistory(val).then((res) => {
    if (res.data.code === API_RETURN_CODE.NO_ERROR) {
      commit('SET_EXCHANGEHISTORY', res.data.data);
    }

    return res.data.code;
  });
};

/**
 * Exchange 내역 현재 페이지
 *  @param {*} param0
 *  @param {Number} val
 */
actions.setExchangeListPageNo = ({ commit }, val) => {
  commit('SET_EXCHANGELISTPAGENO', val);
};

/**
 * Exchange 내역 시작일
 *  @param {*} param0
 *  @param {String} val
 */
actions.setExchangeListStartDate = ({ commit }, val) => {
  commit('SET_EXCHANGELISTSTARTDATE', val);
};

/**
 * Exchange 내역 종료일
 *  @param {*} param0
 *  @param {String} val
 */
actions.setExchangeListEndDate = ({ commit }, val) => {
  commit('SET_EXCHANGELISTENDDATE', val);
};

/**
 * Exchange 내역 상태
 *  @param {*} param0
 *  @param {Number} val
 */
actions.setExchangeListStatus = ({ commit }, val) => {
  commit('SET_EXCHANGELISTSTATUS', val);
};

/**
 * Exchange 상세 내역
 *  @param {*} param0
 *  @param {Number} val
 */
actions.setExchangeDetail = ({ commit }, val) => {
  commit('SET_EXCHANGEDETAIL', val);
  if (val === -1) {
    removeClass(document.body, 'scroll_hide_layer');
  } else {
    addClass(document.body, 'scroll_hide_layer');
  }
};

/**
 * Exchange 상세 내역에서 계좌정보 수정
 *  @param {*} param0
 *  @param {Boolean} val
 */
actions.setExchangeDetailAccount = ({ commit }, val) => {
  commit('SET_EXCHANGEDETAILACCOUNT', val);
};

/**
 * Exchange 상세내역 계좌정보 변경 은행명 선택 정보
 *  @param {*} param0
 *  @param {String} val
 */
actions.setBankSelect = ({ commit }, val) => {
  commit('SET_BANKSELECT', val);
};

actions.setIsNjPointWithdraw = ({ commit }, val) => {
  commit('SET_IS_NJPOINT_WITHDRAW', val);
};

export default {
  ...actions,
};
